/* eslint-disable @typescript-eslint/ban-types */
import { gql, LazyQueryHookOptions, QueryTuple } from '@apollo/client';

import { useAPILazyQuery } from 'Api/handler';

export type ExportCSVResponse = {
  exportCSV: {};
};

export type ExportCSVVariables = {
  originCountry?: string;
  destinationCountry?: string;
  departureDept?: string;
  arrivalDept?: string;
  status?: number[];
  shipper?: number;
  client?: number;
  type: string;
};

export const useExportCSV = (
  options?: LazyQueryHookOptions<ExportCSVResponse, ExportCSVVariables>,
): QueryTuple<ExportCSVResponse, ExportCSVVariables> => {
  return useAPILazyQuery(EXPORT_CSV, options);
};

export const EXPORT_CSV = gql`
  query ExportCSV(
    $originCountry: String
    $destinationCountry: String
    $departureDept: String
    $arrivalDept: String
    $status: [Float]
    $shipper: Float
    $client: Float
    $type: String
  ) {
    exportCSV(
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      departureDept: $departureDept
      arrivalDept: $arrivalDept
      status: $status
      shipper: $shipper
      client: $client
      type: $type
    )
  }
`;
